import { createContext, useContext } from "react";
import { MetaList } from "./meta-list";

const Presentation = createContext<"classic" | "current">("current");
export const ReportPresentationProvider = Presentation.Provider;
export const useReportPresentation = () => useContext(Presentation);

/** The shell chooses the presentation; report payloads and calculations stay shared. */
export const ReportMetadata = ({
  children,
  className,
}: {
  children: string[];
  className?: string;
}) =>
  useReportPresentation() === "classic" ? (
    <span className={className}>{children.join(" · ")}</span>
  ) : (
    <MetaList className={className}>{children}</MetaList>
  );
